module.exports = __webpack_public_path__ + "a4e667f8f5496c278c106fd543a339dd.MP3";